import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logoImage from "../../assets/media/image/logo-property-nexus-removebg-preview.png";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TextField, InputAdornment, Link as MuiLink } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { baseUrl } from "../../Redux/BaseUrl/baseurl";

function Login() {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);

    const handleChangeRememberMe = () => {
        setRememberMe(!rememberMe);
    };

    const handleChange = () => {
        setShowPassword(!showPassword);
    };

    const values = {
        username: "",
        password: ""
    };

    const [auth, setAuth] = useState(values);
    const [formErrors, setFormErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChangeAuthInput = e => {
        const { name, value } = e.target;
        setAuth({
            ...auth,
            [name]: value
        });
    };

    const Login = () => {
        const data = {
            method: "POST",
            body: JSON.stringify({
                email: auth.username,
                password: auth.password
            }),
            headers: {
                "Content-Type": "application/json"
            }
        };

        console.log("login data", data);

        fetch(`${baseUrl}/admins/login`, data)
            .then(response => response.json())
            .then(data => {
                console.log("login response", data);

                if (data.status == true) {
                    toast.success(data.message);
                    if (data.user.role == 3) {
                        navigate("/Prop-InvestorDashboard");
                    } else if (data.user.role == 1) {
                        navigate("/dashboard");
                    }
                    localStorage.setItem("token", data.token);
                    localStorage.setItem("adminId", data.user.id);
                    localStorage.setItem("adminRole", data.user.role);
                    localStorage.setItem("accessedMenuList", data.user.menu);
                } else {
                    toast.error(data.message);
                }
                if (rememberMe) {
                    localStorage.setItem("rememberedUsername", auth.username);
                } else {
                    localStorage.removeItem("rememberedUsername");
                }
            })
            .catch(err => {
                console.log("Login error", err);
                toast.error(err);
            });
    };

    const validate = auth => {
        let errors = {};
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

        if (!auth.username) {
            errors.username = "Username cannot be blank";
        } else if (!auth.password) {
            errors.password = "Password cannot be blank";
        } else if (auth.password.length < 4) {
            errors.password = "Password must be more than 4 characters";
        }
        return errors;
    };

    const handleSubmit = e => {
        e.preventDefault();
        setFormErrors(validate(auth));
        setIsSubmitting(true);
    };

    return (
        <div className="form-membership">
            <ToastContainer />
            <div className="form-wrapper" style={{ height: "auto" }}>
                <div className="navbar-brand ">
                    <Link to="/">
                        <img
                            src={logoImage}
                            alt="Property Nexus"
                            height={90}
                            width={285}
                        />
                    </Link>
                </div>
                <form className="py-4" onSubmit={handleSubmit}>
                    <div className="form-group mb-3">
                        <TextField
                            sx={{ width: "100%" }}
                            placeholder="Username or email"
                            type="text"
                            name="username"
                            value={auth.username}
                            onChange={handleChangeAuthInput}
                        />
                        <p style={{ color: "red" }}>{formErrors.username}</p>
                    </div>
                    <div className="form-group mb-3">
                        <TextField
                            sx={{ width: "100%" }}
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            name="password"
                            value={auth.password}
                            onChange={handleChangeAuthInput}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment
                                        position="end"
                                        sx={{ backgroundColor: "#ffffff" }}
                                    >
                                        {showPassword ? (
                                            <VisibilityOff
                                                onClick={handleChange}
                                            />
                                        ) : (
                                            <Visibility
                                                onClick={handleChange}
                                            />
                                        )}
                                    </InputAdornment>
                                )
                            }}
                        />
                        <p style={{ color: "red" }}>{formErrors.password}</p>
                    </div>
                    <div
                        className="form-group mb-3"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >
                        <label>
                            <input
                                type="checkbox"
                                checked={rememberMe}
                                onChange={handleChangeRememberMe}
                            />
                            &nbsp; Remember me
                        </label>
                        <p style={{ margin: "3px" }}>
                            <MuiLink component={Link} to="/reset-password">
                                Forgot Password?
                            </MuiLink>
                        </p>
                    </div>

                    <button
                        style={{ background: "rgb(44, 59, 82)" }}
                        className="btn btn-primary btn-block "
                        onClick={Login}
                    >
                        Log In
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Login;
